import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import iconPencil from "../img/icons/icon-pencil.svg";
import iconTrash from "../img/icons/icon-trash.svg";

export default function ProposalExpense(prop) {
    let proposalId = prop.proposalId;
    let member = prop.member;
    let readOnly = prop.readOnly;

    let refDetail = React.useRef();
    let refQuantity = React.useRef();
    let refUnit = React.useRef();
    let refPerson = React.useRef();
    let refTime = React.useRef();
    let refPrice = React.useRef();
    let refBudget = React.useRef();
    let refTotal = React.useRef();

    let [typeId, setTypeId] = React.useState(null);
    let [subTypeId, setSubTypeId] = React.useState(null);
    let [showForm, setShowForm] = React.useState(false);
    let [listing, setListing] = React.useState(null);
    let [typeListing, setTypeListing] = React.useState(null);
    let [subTypeListing, setSubTypeListing] = React.useState(null);
    let [editId, setEditId] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const proRes = await getList();
                setListing(proRes);

                const typeList = await Utils.getExpensesType();
                setTypeListing(typeList);

                const subTypeList = await Utils.getExpensesSubType();
                setSubTypeListing(subTypeList);
            } catch (e) {
                //
            }
        })();
    }, []);

    const onAddNew = () => {
        refDetail.current.value = '';
        refQuantity.current.value = '';
        refUnit.current.value = ''; 
        refPerson.current.value = '';
        refTime.current.value = '';
        refPrice.current.value = '';
        refBudget.current.value = '';
        refTotal.current.value = '';
        setTypeId(null);
        setSubTypeId(null);
        setShowForm(true);
        setEditId(null);
    };
    const onCancel = () => {
        setShowForm(false);
    };
    const onEdit = async (id) => {
        const result = await getListView(id);
        if(result) {
            setEditId(id);
            setShowForm(true);
            setTypeId(result.typeId);
            setSubTypeId(result.subTypeId);
            refDetail.current.value = result.detail;
            refQuantity.current.value = result.quantity;
            refUnit.current.value = result.unit;
            refPerson.current.value = result.personItem;
            refTime.current.value = result.timeMonth;
            refPrice.current.value = result.unitPrice;
            refBudget.current.value = result.budget;
            refTotal.current.value = result.total;
        }
    };
    const onSubmit = () => {
        let detail = refDetail.current.value;
        let quantity = refQuantity.current.value;
        let unit = refUnit.current.value;
        let personItem = refPerson.current.value;
        let timeMonth = refTime.current.value;
        let unitPrice = refPrice.current.value;
        let budget = refBudget.current.value;
        let total = refTotal.current.value;

        if(!typeId) {
            toast.error(prop.lang === 'en' ? 'Please specify type':'กรุณาระบุ หมวดงบประมาณ-จำแนกตามประเภทค่าใช้จ่าย');
        }
        else if(typeId && (parseInt(typeId) === Utils.PROPOSAL_EXPENSES_OPERATING || parseInt(typeId) === Utils.PROPOSAL_EXPENSES_INVESTMENT) && !subTypeId) {
            toast.error(prop.lang === 'en' ? 'Please specify sub type':'กรุณาระบุ ประเภทย่อย');
        }
        else if(detail === '') {
            toast.error(prop.lang === 'en' ? 'Please specify detail':'กรุณาระบุ ลักษณะประโยชน์ที่ได้รับ');
            refDetail.current.focus();
        }
        else if(quantity === '') {
            toast.error(prop.lang === 'en' ? 'Please specify quantity':'กรุณาระบุ จำนวน');
            refQuantity.current.focus();
        }
        else if(unit === '') {
            toast.error(prop.lang === 'en' ? 'Please specify unit':'กรุณาระบุ หน่วยนับ');
            refUnit.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                id: editId,
                                proposalId: proposalId,
                                typeId: typeId,
                                subTypeId: subTypeId,
                                detail: detail,
                                quantity: quantity,
                                unit: unit,
                                personItem: personItem,
                                timeMonth: timeMonth,
                                unitPrice: unitPrice,
                                budget: budget,
                                total: total,
                                createdBy: -1,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await createItem(param);

                            if(result) {
                                if(result.status === 'success') {

                                    refDetail.current.value = '';
                                    refQuantity.current.value = '';
                                    refUnit.current.value = '';
                                    refPerson.current.value = '';
                                    refTime.current.value = '';
                                    refPrice.current.value = '';
                                    refBudget.current.value = '';
                                    refTotal.current.value = '';
                                    setSubTypeId(null);

                                    toast.success(prop.lang === 'en' ? 'Add detail successfully.':'บันทึกส่วนข้อมูลกลุ่มผู้ได้รับประโยชน์ เรียบร้อย');
                                    setShowForm(false);
                                    const teamRes = await getList();
                                    setListing(teamRes);
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };
    const onDelete = (id) => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        const result = await deleteItem(id);
                        if(result) {
                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Delete successfully.':'ลบข้อมูล เรียบร้อย');
                                setShowForm(false);
                                const teamRes = await getList();
                                setListing(teamRes);
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                        else {
                            toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    async function createItem(param) {
        const response = await fetch(Config.apiUrl +'/proposalExpense/' + (editId ? 'updateItem':'createItem'), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getList() {
        const response = await fetch(Config.apiUrl +'/proposalExpense/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getListView(id) {
        const response = await fetch(Config.apiUrl +'/proposalExpense/viewItem', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function deleteItem(id) {
        const response = await fetch(Config.apiUrl +'/proposalExpense/deleteItem', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onChangeTypeId = (x) => {
        setTypeId(x.target.value);
    };

    const onChangeSubTypeId = (x) => {
        setSubTypeId(x.target.value);
    };

    return (
        <>
            <div className="row g-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between gap-3">
                        <h6 className="pt-1"></h6>
                        {
                            readOnly ? '' : <button className="btn btn-xs btn-light-2" onClick={onAddNew}>
                                {prop.lang === 'en' ? '+ Add New':'+ เพิ่มรายการ'}
                            </button>
                        }
                    </div>
                    <div className="table-responsive mt-3">
                        <table className="table table-info table-hover text-center" style={{whiteSpace: 'nowrap'}}>
                            <thead>
                            <tr>
                                <th className="text-start">{prop.lang === 'en' ? 'Type':<>หมวดงบประมาณ<br />จำแนกตาม<br />ประเภทค่าใช้จ่าย</>}</th>
                                <th className="text-start">{prop.lang === 'en' ? 'Detail':'รายละเอียดงบประมาณ'}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Quantity':'จำนวน'}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Unit':'หน่วยนับ'}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Unit':<>คน/<br />รายการ</>}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Unit':<>ครั้ง/<br />เดือน</>}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Unit':<>ราคา<br />ต่อหน่วย</>}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Unit':<>งบประมาณ<br />บาท</>}</th>
                                <th className="text-center">{prop.lang === 'en' ? 'Unit':<>งบประมาณรวม<br />ในรายการค่าใช้จ่าย (บาท)</>}</th>
                                {
                                    readOnly ? '' : <th style={{width: '100px'}}>แก้ไข</th>
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {
                                listing !== null && listing.count > 0 ?
                                    listing.rows.map((row, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-start">
                                                    {
                                                        prop.lang === 'en' ? typeListing.filter((e) => e.id===row.typeId)[0].title_en : typeListing.filter((e) => e.id===row.typeId)[0].title
                                                    }
                                                </td>
                                                <td className="text-start">{row.detail}</td>
                                                <td className="text-center" style={{width:'100px'}}>{row.quantity}</td>
                                                <td className="text-center" style={{width:'100px'}}>{row.unit}</td>
                                                <td className="text-center" style={{width:'100px'}}>{row.personItem}</td>
                                                <td className="text-center" style={{width:'100px'}}>{row.timeMonth}</td>
                                                <td className="text-center" style={{width:'100px'}}>{row.unitPrice}</td>
                                                <td className="text-center" style={{width:'100px'}}>{row.budget}</td>
                                                <td className="text-center" style={{width:'100px'}}>{row.total}</td>
                                                {
                                                    readOnly ? '' : <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className="btn btn-trans" onClick={e => onEdit(row.id)}>
                                                                <img className="icons svg-js trash" src={iconPencil} alt="" />
                                                            </button>
                                                            <button className="btn btn-trans" onClick={e => onDelete(row.id)}>
                                                                <img className="icons svg-js trash" src={iconTrash} alt="" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                }
                                            </tr>
                                        )
                                    }) : <tr><td colSpan={5}>-</td></tr>
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className={"row g-3 mt-2" + (showForm ? '':' d-none')}>
                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Budget category - classified by expense type':'หมวดงบประมาณ-จำแนกตามประเภทค่าใช้จ่าย'} <span className="star">*</span></h6>
                                <select className="form-select" onChange={onChangeTypeId} value={typeId} disabled={readOnly}>
                                    <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                    {
                                        typeListing !== null ?
                                            typeListing.map((row, index) => {
                                                return (
                                                    <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                )
                                            }) : ''
                                    }
                                </select>
                            </div>
                        </div>
                        {
                            parseInt(typeId) === Utils.PROPOSAL_EXPENSES_OPERATING || parseInt(typeId) === Utils.PROPOSAL_EXPENSES_INVESTMENT ?
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Sub Type':'ประเภทย่อย'} <span className="star">*</span></h6>
                                        <select className="form-select" onChange={onChangeSubTypeId} value={subTypeId} disabled={readOnly}>
                                            <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                            {
                                                subTypeListing !== null ?
                                                    subTypeListing.filter(e => e.typeId === parseInt(typeId)).map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    }) : ''
                                            }
                                        </select>
                                    </div>
                                </div> : ''
                        }
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Detail':'รายละเอียดงบประมาณ'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refDetail} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Quantity':'จำนวน'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refQuantity} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Unit':'หน่วยนับ'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refUnit} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'People/Items':'คน/รายการ'} <span className="star">*</span></h6>
                                <input type="number" className="form-control text-center" ref={refPerson} maxLength={11} min={1} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Time/Month':'ครั้ง/เดือน'} <span className="star">*</span></h6>
                                <input type="number" className="form-control text-center" ref={refTime} maxLength={11} min={1} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Price/Unit':'ราคาต่อหน่วย'} <span className="star">*</span></h6>
                                <input type="number" className="form-control text-center" ref={refPrice} maxLength={11} min={1} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Budget Price':'งบประมาณ (บาท)'} <span className="star">*</span></h6>
                                <input type="number" className="form-control text-center" ref={refBudget} maxLength={11} min={1} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Total budget in expense list':'งบประมาณรวมในรายการค่าใช้จ่าย (บาท)'} <span className="star">*</span></h6>
                                <input type="number" className="form-control text-center" ref={refTotal} maxLength={11} min={1} />
                            </div>
                        </div>

                        <div className="col-12 mt-4">
                            <div className="buttons gap-15 py-0">
                                <button className="btn btn-xs btn-green" type="button" onClick={onSubmit}>
                                    {prop.lang === 'en' ? 'Save':'บันทึก'}
                                </button>
                                <button className="btn btn-xs btn-gray me-auto" type="button" onClick={onCancel}>
                                    {prop.lang === 'en' ? 'Cancel':'ยกเลิก'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 